/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */


import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminHeaderClassifierService {

  constructor(private http: HttpClient) { }

  getHeaderTraining(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/headerclassifier/training`
      );
  }

  newHeaderTraining(model: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/headerclassifier/training`,
        JSON.stringify(model)
      );
  }

  updateHeaderTraining(id: string, model: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/admin/headerclassifier/training/${id}`,
        JSON.stringify(model)
      );
  }

  deleteHeaderTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/headerclassifier/training/${id}`
      );
  }
}


// WEBPACK FOOTER //
// ./client/app/services/admin/admin-headerclassifier.service.ts